import { GridProps } from '@material-ui/core'

export const defaultGridProps: GridProps = {
  xs: 12,
  md: 6,
  lg: 4,
  xl: 3
}
